import { ElementProps } from "../../../types/common";

export const LinkIcon = (props: ElementProps) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m5.768 8.93-.95.95a2.237 2.237 0 0 1-3.163-3.164l1.898-1.898a2.237 2.237 0 0 1 3.164 0"
      stroke="#000"
      strokeLinecap="round"
    />
    <path
      d="m5.77 2.604.948-.949A2.237 2.237 0 0 1 9.882 4.82L7.984 6.717a2.237 2.237 0 0 1-3.164 0"
      stroke="#000"
      strokeLinecap="round"
    />
  </svg>
);
